import { gql } from '__generated__';

export default gql(`
  mutation DeleteParticipantField($id: ID!) {
    deleteParticipantField(id: $id)
  }
`);
